import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordAppleIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.58867 2.58867C7.04681 3.13053 6.01888 2.98112 6.01888 2.98112C6.01888 2.98112 5.86947 1.95319 6.41133 1.41133C6.95319 0.869467 7.98112 1.01888 7.98112 1.01888C7.98112 1.01888 8.13053 2.04681 7.58867 2.58867Z"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeLinejoin="round"
      />
      <path
        d="M2 7.02967C2 8.67052 3.09823 10.5552 4.20945 10.9534C4.5947 11.0915 4.99289 10.901 5.32395 10.6637C5.57509 10.4837 5.87921 10.3118 6.12483 10.3118C6.37045 10.3118 6.67457 10.4837 6.92572 10.6637C7.25677 10.901 7.65497 11.0915 8.04022 10.9534C8.82983 10.6704 9.61288 9.63692 10 8.47367C9.25039 8.25897 8.70285 7.5807 8.70285 6.7772C8.70285 6.04106 9.16242 5.41005 9.8159 5.14431C9.39486 4.39654 8.7068 4 7.92945 4C7.5273 4 7.15772 4.16211 6.85915 4.35643C6.38263 4.66657 5.86703 4.66657 5.39051 4.35643C5.09195 4.16211 4.72236 4 4.32022 4C3.0388 4 2 5.07756 2 7.02967Z"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BordAppleIcon;
